import { useApi } from '@/api'

export const useInvitationsResource = () => {
  const api = useApi()
  const acceptance = api.api.v1.invitations.accept

  type AcceptBody = Parameters<typeof acceptance.post>[0]

  return {
    setInvitationAcceptance: (body: AcceptBody) => acceptance.post(body)
  }
}
